/**
 * API helpers for the image title overlay. Everything goes through crudApi so
 * auth headers, quota handling and toasts stay consistent with the rest of the app.
 */
import crudApi from "@serie3/common/api/crudApi";
import DocumentsEndpoints from "../../Documents/endpoints";
import { normalizeOverlay } from "./overlayRenderer";

/**
 * Persists the overlay of one post/image connection.
 *
 * The column stays NULL until something is actually changed — and NULL means
 * "on, with the defaults", so an untouched image still gets its title.
 */
export const saveOverlay = async (documentPostId, overlay, noToast = true) =>
  crudApi.edit(
    DocumentsEndpoints.overlay,
    { document_post_id: documentPostId, overlay: normalizeOverlay(overlay) },
    noToast
  );

/**
 * Downloads the image with the title burned in.
 *
 * The overlay is saved first so the file matches what is on screen — the editor
 * autosaves on a debounce, and without this a download right after an edit would
 * render the previous state.
 */
export const downloadRendered = async (documentPostId, overlay, filename = "image-title.jpg") => {
  await saveOverlay(documentPostId, overlay);

  const response = await crudApi.getBinary(
    DocumentsEndpoints.overlayRender + documentPostId
  );
  if (response.status !== 200) {
    return false;
  }

  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoking immediately can cancel the download in some browsers.
  setTimeout(() => window.URL.revokeObjectURL(url), 10000);

  return true;
};

const overlayApi = { saveOverlay, downloadRendered };

export default overlayApi;
